import { render, staticRenderFns } from "./addserversList.vue?vue&type=template&id=496d219a&"
import script from "./addserversList.vue?vue&type=script&lang=js&"
export * from "./addserversList.vue?vue&type=script&lang=js&"
import style0 from "./addserversList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496d219a')) {
      api.createRecord('496d219a', component.options)
    } else {
      api.reload('496d219a', component.options)
    }
    module.hot.accept("./addserversList.vue?vue&type=template&id=496d219a&", function () {
      api.rerender('496d219a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/addserversList.vue"
export default component.exports